namespace Serenity.EmailClient {

    export const folderIcons = {
        "inbox": "fa-inbox",
        "sent": "fa-envelope-o",
        "drafts": "fa-file-text-o",
        "junk": "fa-filter",
        "trash": "fa-trash-o"
    };

    function folderIcon(folder: EmailFolder) {
        return "fa " + (folderIcons[folder.Kind] || 'fa-folder-o');
    }

    export interface MailboxFolderLinkProps {
        folder: EmailFolder;
        activeFolder: string;
    }

    export function mailboxFolderName(folder: EmailFolder) {
        return Q.tryGetText("Site.EmailClient.FolderNames." + folder.Kind) ||
            folder.Name || folder.FullName || '';
    }

    export class MailboxFolderLink extends React.Component<MailboxFolderLinkProps> {

        render(): React.ReactNode {
            return (
                <li>
                    <a href={'#folder/' + encodeURIComponent(this.props.folder.FullName)}
                        className={this.props.folder.FullName == this.props.activeFolder ? "active" : ""}>
                        <i className={folderIcon(this.props.folder)}></i> <span>
                            {mailboxFolderName(this.props.folder)}
                            {this.props.folder.UnreadCount > 0 &&
                                <span className="label label-primary pull-right">
                                    {this.props.folder.UnreadCount}
                                </span>}
                        </span>
                    </a>
                    {this.props.folder.SubFolders && 
                        <ul>
                        {this.props.folder.SubFolders.map(sub =>
                            <MailboxFolderLink folder={sub}
                                activeFolder={this.props.activeFolder}
                                key={sub.FullName} />)
                        }
                        </ul>
                    }
                </li>
            );
        }
    }
}